import { render } from "./PaymentSignaturePanel.vue?vue&type=template&id=6365b5cd"
import script from "./PaymentSignaturePanel.vue?vue&type=script&lang=js"
export * from "./PaymentSignaturePanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__